const CardDetailState = (function states() {
    return {
        labelList: [],
        languageList: [],
    }
})()

export default CardDetailState;